// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1w-Qo","boxTitle":"Qualiphy_boxTitle__4fx4E","box":"Qualiphy_box__3z-c5","toggleWrap":"Qualiphy_toggleWrap__22lzw"};